<template>
  <div>
    <header>
      <Header />
      <BreadcrumbList />
    </header>
    <div>
      <div id="main">
        <section class="photographersList">
          <div class="photographersListTitle">
            <div class="inner4">
              <h1>展示者一覧</h1>
              <p class="titleSub">Online Exhibition</p>
            </div><!-- /inner2-->
          </div><!-- /photographersListTitle-->
          <div class="photographersListBody">
            <div class="inner2">
              <div v-for="awardType in awardTypes" class="listBlock" :key="awardType">
                <h2>{{awardTypeNames[awardType]}}</h2>
                <ul>
                  <li v-for="winner in winnersByAwardType(awardType)" :key="winner.id">
                    <router-link :to="{ name: 'artworksWinner', params: { awardTypeCode: getArtworksCode(winner), id: winner.id }}">
                      {{winner.name}}
                    </router-link>
                  </li>
                </ul>
              </div><!-- /listBlock-->
            </div><!-- /inner-->
          </div><!-- /photographersListBody-->
        </section><!-- /photobook-->
      </div><!-- /main-->
    </div>
    <Footer />
    <UpButton />
    <QuestionnaireButton />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'
import QuestionnaireButton from '@/components/modules/QuestionnaireButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    BreadcrumbList,
    UpButton,
    QuestionnaireButton
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'winners',
      'winnersByAwardType'
    ])
  },
  methods: {
    getArtworksCode (winner) {
      if (!this.awardTypeCode || !winner) return
      return this.awardTypeCode[winner.awardType]
    },
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  created () {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
